const middleware = {}

middleware['collaboration-access'] = require('../middleware/collaboration-access.js')
middleware['collaboration-access'] = middleware['collaboration-access'].default || middleware['collaboration-access']

export default middleware
